import React from 'react';
import {DateRangeSelector} from './components/DateRangeSelector';
import {AssigneeFilter} from './components/AssigneeFilter';
import {ScoreFilter} from './components/ScoreFilter';
import {ScoreHistoryTable} from './components/table';
import {ScoreHistoryChart} from './components/ScoreHistoryChart';

export default () => {
  return (
    <div className="flex flex-col gap-8">
      <div className="border border-c-border rounded p-2 bg-white">
        <div className="flex items-center gap-4">
          <DateRangeSelector />
          <AssigneeFilter />
          <ScoreFilter />
        </div>
      </div>
      <ScoreHistoryChart />
      <ScoreHistoryTable />
    </div>
  );
};
